// React Thirty Party Library
import React, { useState } from "react";
import { Table, Pagination } from "antd"

// Constants Library

// Components Library

// Handler Library 
// import { table_handler } from '../../../../handlers'

// Services Library
// import { TIME } from "../../../../services/util";

// Redux Actions

// Styles Library
import "../../index.css"

// const { getColumnSearchProps } = table_handler
// const { parseDate } = TIME

// const DriverPerfomanceTripDetails = (searchTextState, searchedColumnState) => [
//   {
//     title: "Trip Start At",
//     dataIndex: "start_time",
//     defaultSortOrder: "ascend",
//     sorter: (a, b) => a.start_time - b.start_time,
//     render: start_time => parseDate(Number(start_time)),
//   },
//   {
//     title: "Trip End At",
//     dataIndex: "end_time",
//     defaultSortOrder: "ascend",
//     sorter: (a, b) => a.end_time - b.end_time,
//     render: end_time => parseDate(Number(end_time)),
//   },
//   {
//     title: "Total Warning Events",
//     dataIndex: "total_warning",
//     ...getColumnSearchProps("Total Warning Events", 'total_warning', searchTextState, searchedColumnState),
//   },
//   {
//     title: "Driver Score",
//     dataIndex: "driver_score",
//     sorter: (a, b) => a.driver_score - b.driver_score,
//   },
// ];

// const DriverPerfomanceScoreDetails = (searchTextState, searchedColumnState) => [
//     {
//       title: "Even Time",
//       dataIndex: "eventAt",
//       defaultSortOrder: "ascend",
//       sorter: (a, b) => a.eventAt - b.eventAt,
//       render: eventAt => parseDate(Number(eventAt)),
//     },
//     {
//       title: "Event Type",
//       dataIndex: "event_type",
//       ...getColumnSearchProps("Event Type", 'event_type', searchTextState, searchedColumnState),
//     },
//     {
//       title: "Frequency",
//       dataIndex: "frequency",
//       sorter: (a, b) => a.frequency - b.frequency,
//     },
// ];

const TableReport = (props) => {
    
  const { dataColumn, dataReport, ModalDriver } = props

  // const ExpandTableItems = (source) => [
  //   {
  //       label: 'Trip Details',
  //       key: 0,
  //       children: (
  //       <Table
  //           columns={DriverPerfomanceTripDetails().filter(c => !c.isHidden)}
  //           dataSource={source}
  //           pagination={false}
  //           scroll = {{
  //               x: DriverPerfomanceTripDetails().length * 150,
  //           }}
  //       />
  //       ),
  //   },
  //   {
  //       label: 'Score Details',
  //       key: 1,
  //       children: (
  //       <Table
  //           columns={DriverPerfomanceScoreDetails().filter(c => !c.isHidden)}
  //           dataSource={source}
  //           pagination={false}
  //           scroll = {{
  //               x: DriverPerfomanceScoreDetails().length * 150,
  //           }}
  //       />
  //       ),
  //   }
  // ];
  
  // const expandedRowRender = () => {
  //   // const { fpid } = record;
    
  //   return (
  //     <Tabs 
  //       items={ExpandTableItems()} 
  //     />
  //   );
  // }; 

  const [ current, setCurrent ] = useState(1)
  const [ pageSize, setPageSize ] = useState(10)
  
  const paginationOnChangeHDLR = (current, pageSize) => {
      setCurrent(current)
      setPageSize(pageSize)
  }

  const startIndex = (current - 1) * pageSize; // pagination
  const endIndex = startIndex + pageSize;

  const paginatedData = dataReport?.slice(startIndex, endIndex)

  return (
    <div>
        { ModalDriver }
        <Table
            columns = {dataColumn.filter(c => !c.isHidden)}
            dataSource = {paginatedData}
            // dataSource = {dataReport}
            pagination = {false}
            scroll = {{
                x: dataColumn.length * 150,
            }}
            // expandable={{
            //     expandedRowRender
            //   }}
        />
        
        <Pagination style={{ float: 'right', marginTop: '12px' }} onChange={paginationOnChangeHDLR} total={dataReport.length} />
  </div>    
  );
};

export default TableReport;